import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Button,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import TimerIcon from '@mui/icons-material/Timer';
import SpeedIcon from '@mui/icons-material/Speed';
import VisibilityIcon from '@mui/icons-material/Visibility';

interface ResultadoLecturaProps {
  tiempoTotal: number; // en segundos
  palabrasLeidas: number;
  comprensionPorcentaje: number;
  onReintentar: () => void;
  onSiguienteEjercicio: () => void;
}

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  margin: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[3],
}));

const ResultadoLectura: React.FC<ResultadoLecturaProps> = ({
  tiempoTotal,
  velocidadLectura,
  //comprensionPorcentaje,
  //onReintentar,
  //onSiguienteEjercicio,
}) => {
  //const velocidadLectura = Math.round((palabrasLeidas / tiempoTotal) * 60);

  return (
    <StyledPaper elevation={3}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <CheckCircleOutlineIcon color="success" sx={{ fontSize: 60, mb: 2 }} />
        <Typography variant="h4" gutterBottom>
          ¡Ejercicio Completado!
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          Has finalizado exitosamente tu ejercicio de lectura.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <List>
        <ListItem>
          <ListItemIcon>
            <TimerIcon color="primary" />
          </ListItemIcon>
          <ListItemText 
            primary="Tiempo total" 
            //secondary={`${Math.floor(tiempoTotal / 60)} minutos ${tiempoTotal % 60} segundos`}
            secondary={`${tiempoTotal} minutos`} 
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <SpeedIcon color="primary" />
          </ListItemIcon>
          <ListItemText 
            primary="Velocidad de lectura" 
            secondary={`${velocidadLectura} palabras por minuto`} 
          />
        </ListItem>
        {/*<ListItem>
          <ListItemIcon>
            <VisibilityIcon color="primary" />
          </ListItemIcon>
          <ListItemText 
            primary="Comprensión" 
            secondary={`${comprensionPorcentaje}%`} 
          />
        </ListItem>*/}
      </List>

      <Box display="flex" justifyContent="space-between" mt={4}>
        {/*<Button variant="outlined" onClick={onReintentar}>
          Reintentar
        </Button>
        <Button variant="contained" onClick={onSiguienteEjercicio}>
          Aceptar
        </Button>*/}
      </Box>
    </StyledPaper>
  );
};

export default ResultadoLectura;

